﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';
import dummy from '../../app/plugins';
import * as nouislider from 'nouislider';

//No internet
require('typeahead-addresspicker');

import tpl_customPomodore from './tpl/customPomodoro.html';
import language from '../../../common/language';
import View_LayoutError from '../../../lib/views/layoutError/layoutError';
import View_Information from '../../../lib/views/information/information';
import * as Entities_Empty from '../../../lib/entities/empty';

import View_DialogWaiting from '../../../lib/views/dialogWaiting/dialogWaiting';
import helper_createWebpage from '../../helper/createWebpage';
import config from '../../../common/config';
import Help from '../../helper/help';
import View_Dialog2Button from '../../../lib/views/dialog2Button/dialog2Button';
import EventUpdate from '../../helper/eventUpdate';
import View_CustomHeader from '../region/customHeader/customHeader';


export default View_LayoutError.extend({
    getTemplate: function () {
        return tpl_customPomodore({ model: this.model.toJSON() });
    },
    attributes: function () {
        return {
            style: "",
        }
    },
    initialize: function () {
        self = this;

        this.app = this.options.app;

        this.informationCollection = new Entities_Empty.Collection();

        this.setHasChanged(false);
        this.oldModel = this.model.clone();
    },
    help: function () {
        Help.help(this, true, 'custom');
    },
    setHasChanged: function (enable) {
        this.hasChanged = enable;
    },
    getHasChanged: function () {
        return this.hasChanged;
    },
    saveHasChanged: function (callback) {
        this.btnSubmitClick();
        callback();
    },
    cancelHasChanged: function () {
        this.model.attributes = this.oldModel.attributes;
    },
    modelHasChanged: function () {
        var changes = false;

        this.setModel();

        //If culture has change do not ask to save when goes to another menu item
        if (this.model.attributes.PomodoroTime == this.oldModel.attributes.PomodoroTime &&
            this.model.attributes.ShortBreak == this.oldModel.attributes.ShortBreak &&
            this.model.attributes.LongBreak == this.oldModel.attributes.LongBreak &&
            this.model.attributes.LongBreakCycle == this.oldModel.attributes.LongBreakCycle) {
            changes = false;
            //this.btnSubmitClick();
        } else if (this.model.attributes.PomodoroTime != this.oldModel.attributes.PomodoroTime &&
            this.model.attributes.ShortBreak != this.oldModel.attributes.ShortBreak &&
            this.model.attributes.LongBreak != this.oldModel.attributes.LongBreak &&
            this.model.attributes.LongBreakCycle != this.oldModel.attributes.LongBreakCycle) {
            changes = true;
        }

        this.setHasChanged(changes);
    },
    regions: {
        information: "#customInformation"
    },
    onBeforeShow: function () {
        this.information.show(new View_Information({ collection: this.informationCollection, app: this.app }));
    },
    ui: {
        'pomodoro_inputPomodoroTime': '#pomodoro_inputPomodoroTime',
        'pomodoro_group_PomodoroTime': '#pomodoro_group_PomodoroTime',

        'pomodoro_inputShortBreak': '#pomodoro_inputShortBreak',
        'pomodoro_group_ShortBreak': '#pomodoro_group_ShortBreak',

        'pomodoro_inputLongBreak': '#pomodoro_inputLongBreak',
        'pomodoro_group_LongBreak': '#pomodoro_group_LongBreak',

        'pomodoro_input_LongBreakCycle': '#pomodoro_input_LongBreakCycle',
        'pomodoro_input_LongBreakCycleValue': '#pomodoro_input_LongBreakCycleValue',
        'custom_btnSubmit': '#custom_btnSubmit',
        'custom_btnDefault': '#custom_btnDefault',
        'help': '#help'
    },
    events: {
        'click #custom_btnSubmit': 'btnSubmitClick',
        'click #custom_btnDefault': 'btnDefaultClick',
        'click #help': 'help'
    },
    onRender: function () {
    },
    onAttach() {
        var self = this;

        this.ui.pomodoro_inputPomodoroTime.durationPicker({
            translations: {
                day: resources.X200259,
                hour: resources.X200260,
                minute: resources.X200261,
                second: resources.X200262,
                days: resources.X200263,
                hours: resources.X200264,
                minutes: resources.X200265,
                seconds: resources.X200266,
            },
            showSeconds: false,
            showDays: false,


            onChanged: function (newVal) {
                self.model.set({
                    PomodoroTime: newVal
                });
            }
        });

        $('.bdp-block.hidden').css('display', 'none');
        $('#pomodoro_group_PomodoroTime').find('.input-sm').width(90);

        this.ui.pomodoro_inputShortBreak.durationPicker({
            translations: {
                day: resources.X200259,
                hour: resources.X200260,
                minute: resources.X200261,
                second: resources.X200262,
                days: resources.X200263,
                hours: resources.X200264,
                minutes: resources.X200265,
                seconds: resources.X200266,
            },
            showSeconds: false,
            showDays: false,


            onChanged: function (newVal) {
                self.model.set({
                    ShortBreak: newVal
                });
            }
        });

        $('.bdp-block.hidden').css('display', 'none');
        $('#pomodoro_group_ShortBreak').find('.input-sm').width(90);

        this.ui.pomodoro_inputLongBreak.durationPicker({
            translations: {
                day: resources.X200259,
                hour: resources.X200260,
                minute: resources.X200261,
                second: resources.X200262,
                days: resources.X200263,
                hours: resources.X200264,
                minutes: resources.X200265,
                seconds: resources.X200266,
            },
            showSeconds: false,
            showDays: false,


            onChanged: function (newVal) {
                self.model.set({
                    LongBreak: newVal
                });
            }
        });

        $('.bdp-block.hidden').css('display', 'none');
        $('#pomodoro_group_LongBreak').find('.input-sm').width(90);

        if ($("#pomodoro_input_LongBreakCycle").length) {
            var startSlider1 = document.getElementById('pomodoro_input_LongBreakCycle');
            nouislider.create(startSlider1, {
                start: self.model.attributes.LongBreakCycle,
                behaviour: 'snap',
                //connect: [true, false],
                range: {
                    min: 1,
                    max: 50
                },
                step: 1
            });
            startSlider1.noUiSlider.on('set', function (e) {
                self.model.attributes.LongBreakCycle = parseInt(e);
                self.ui.pomodoro_input_LongBreakCycleValue.html(parseInt(e));
            });
        }
        
    },
    onDestroy() {
       
    },
    renderInformation: function () {
        this.informationCollection.reset();

        //No customYet yet
        if (this.model.validateNoBackbone(this.model.attributes)) {
            var tmpModel = new this.informationCollection.model({ toastType: 3, header: resources.X100229, Information: resources.X100333 });
            this.informationCollection.add(tmpModel);
        }
        this.app.renderInformation({ informationCollection: this.informationCollection });
    },
    updateInformationCollection: function () {
        this.renderInformation();
        this.informationCollection.trigger('change');
    },
    btnSubmitClick: function (event) {
        if (event != null) {
            event.preventDefault();
        }

        if (this.setModel()) {
            this.save();
        }
    },
    btnDefaultClick: function (event) {
        var self = this;
        if (event != null) {
            event.preventDefault();
        }


        this.model.set({
            PomodoroTime: this.app.entities.collections.CustomDefaultSetting01.models[0].attributes.Data.PomodoroTime,
            ShortBreak: this.app.entities.collections.CustomDefaultSetting01.models[0].attributes.Data.ShortBreak,
            LongBreak: this.app.entities.collections.CustomDefaultSetting01.models[0].attributes.Data.LongBreak,
            LongBreakCycle: this.app.entities.collections.CustomDefaultSetting01.models[0].attributes.Data.LongBreakCycle
        });

        if (this.setModel()) {
            /*this.save();*/
            self.options.tmpModelData.attributes.Data = self.model.toJSON();
            var strJson = JSON.stringify(self.options.moduleCollection.toJSON());
            self.options.customDefaultSetting.attributes.Data = '[{ "Collection" : ' + strJson + '}]';


            self.options.customDefaultSetting.save(self.options.customDefaultSetting.attributes, {
                route01: false,
                success: function () {
                    dialogWaiting.triggerMethod('dialog:close');

                    var userChannel = Backbone.Radio.channel('app');
                    userChannel.trigger('Region_Header:setLoginName');

                    self.oldModel = self.model.clone();
                    self.setHasChanged(false);
                }
            });

            this.app.router.navigate("#customPomodoro");
            this.app.router.customPomodoro();
        }
    },
    setModel: function () {
        return true;
    },
    save: function () {
        var self = this;

        var strJson = self.model.toJSON();
        var data = '[{ "Collection" : ' + strJson + '}]';

        var strJson = JSON.stringify(this.options.moduleCollection.toJSON());

        var callback = function (ret) {
            if (ret == false) {

                var dialogWaitingModel = new Entities_Empty.Model();
                dialogWaitingModel.attributes.Title = resources.X100232;
                dialogWaitingModel.attributes.Text = resources.X200093;
                dialogWaitingModel.attributes.Button = resources.X100279;

                var dialogWaiting = new View_DialogWaiting({ model: dialogWaitingModel, parent: self });
                var callback = function (options) {
                    self.stopListening(dialogWaiting, "dialog:okclicked", callback);
                }
                self.listenTo(dialogWaiting, "dialog:okclicked", callback);
                self.app.dialogRegion.show(dialogWaiting);

                self.options.tmpModelData.attributes.Data = self.model.toJSON();
                var strJson = JSON.stringify(self.options.moduleCollection.toJSON());
                self.options.customDefaultSetting.attributes.Data = '[{ "Collection" : ' + strJson + '}]';


                self.options.customDefaultSetting.save(self.options.customDefaultSetting.attributes, {
                    route01: false,
                    success: function () {
                        dialogWaiting.triggerMethod('dialog:close');

                        var userChannel = Backbone.Radio.channel('app');
                        userChannel.trigger('Region_Header:setLoginName');

                        self.oldModel = self.model.clone();
                        self.setHasChanged(false);
                    }
                });
            } else {
                self.showErrors(self.model.errors);
            }
        }

        callback(false);

        //this.hideErrors();

        //var ret = this.model.validateNoBackbone(this.model.attributes, callback);
        //if (ret == false) {

        //    var dialogWaitingModel = new Entities_Empty.Model();
        //    dialogWaitingModel.attributes.Title = resources.X100232;
        //    dialogWaitingModel.attributes.Text = resources.X200093;
        //    dialogWaitingModel.attributes.Button = resources.X100279;

        //    var dialogWaiting = new View_DialogWaiting({ model: dialogWaitingModel, parent: this });
        //    var callback = function (options) {
        //        self.stopListening(dialogWaiting, "dialog:okclicked", callback);
        //    }
        //    this.listenTo(dialogWaiting, "dialog:okclicked", callback);
        //    this.app.dialogRegion.show(dialogWaiting);


        //    this.model.save(this.model.attributes, {
        //        route01: false,
        //        success: function () {
        //            dialogWaiting.triggerMethod('dialog:close');

        //            var userChannel = Backbone.Radio.channel('app');
        //            userChannel.trigger('Region_Header:setLoginName');

        //            self.oldModel = this.model.clone();
        //            self.setHasChanged = false;
        //        }
        //    });
        //} else {
        //    this.showErrors(this.model.errors);
        //}
    }
}, Backbone.Radio.Requests);
